export default __webpack_public_path__ + "static/media/notification_icon.9d9829b6.6435e546.svg";